import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Welcome from "@/pages/Welcome";
import LanguageSelect from "@/pages/LanguageSelect";
import MainScreen from "@/pages/MainScreen";
import CineVision from "@/pages/CineVision";
import SceneAnalysis from "@/pages/SceneAnalysis";
import ARCamera from "@/pages/ARCamera";
import Filters from "@/pages/Filters";
import Templates from "@/pages/Templates";
import Training from "@/pages/Training";
import Settings from "@/pages/Settings";
import BottomNav from "@/components/BottomNav";
import PresentationShell from "@/components/PresentationShell";
import { useApp } from "@/context/AppContext";

function AppLayout({ children }) {
  const { presentation } = useApp();
  if (presentation) return <PresentationShell>{children}</PresentationShell>;
  return (
    <div className="min-h-screen pb-24 max-w-lg mx-auto relative">
      {children}
      <BottomNav />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AppProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Welcome />} />
              <Route path="/language" element={<LanguageSelect />} />
              <Route path="/app" element={<AppLayout><MainScreen /></AppLayout>} />
              <Route path="/app/cinevision" element={<AppLayout><CineVision /></AppLayout>} />
              <Route path="/app/analysis" element={<AppLayout><SceneAnalysis /></AppLayout>} />
              <Route path="/app/camera" element={<AppLayout><ARCamera /></AppLayout>} />
              <Route path="/app/filters" element={<AppLayout><Filters /></AppLayout>} />
              <Route path="/app/templates" element={<AppLayout><Templates /></AppLayout>} />
              <Route path="/app/training" element={<AppLayout><Training /></AppLayout>} />
              <Route path="/app/settings" element={<AppLayout><Settings /></AppLayout>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AppProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
